import { Button } from "@mui/material";
import { QUERY_KEYS } from "constant/react_query";
import { useSetCharactersFromText } from "hooks/asocijator/topic/input_way_text/useSetCharactersFromText";
import toast from "react-hot-toast";
import styled from "styled-components";

type CharUpdateFromTextProps = {
  topicId: string;
};

const CharUpdateFromText = ({ topicId }: CharUpdateFromTextProps) => {
  const { setCharactersFromTextMutate } = useSetCharactersFromText({
    invalidateKeysArray: [
      [QUERY_KEYS.ASOCIJATOR_CHARACTER_SEARCH],
      [QUERY_KEYS.ASOCIJATOR_CHARACTER_LIST_GET],
    ],
  });

  const updateFromText = () => {
    console.log("updateFromText");
    setCharactersFromTextMutate({ topicId });
    toast.success("Characters from text set");
  };

  return (
    <div>
      <Button onClick={updateFromText} variant="outlined">
        UPDATE FROM TEXT
      </Button>
    </div>
  );
};

export default CharUpdateFromText;
